/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  MenuItem,
  Menu,
  Container,
  // Button,
  Tabs,
  Tab,
  Divider,
} from "@common-ui/ui";
import MenuIcon from "@mui/icons-material/Menu";
import styled from "@emotion/styled";
import { AccountMenu } from "./AccountSetting";
import AppSwitcher from "./AppSwitcher";

import { Logo } from "./Logo";
// import { SwitchOrganization } from "./SwitchOrganization";

const pages = ["Home", "Assets", "Work", "My Org", "Clients"];

function a11yProps(index) {
  return {
    id: `columbia-tab-${index}`,
    "aria-controls": `columbia-tab-${index}`,
  };
}

const ResponsiveAppBar = (props) => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  let testValue = false;
  if (window?.location.pathname === "/") {
    testValue = 0;
  } else if (window?.location.pathname === "/asset-list") {
    testValue = 1;
  } else if (window?.location.pathname === "/work-events") {
    testValue = 2;
  } else if (
    window?.location.pathname === `/my-org/${currentOrganization?.id}`
  ) {
    testValue = 3;
  } else if (window?.location.pathname === "/customers") {
    testValue = 4;
  } else {
    testValue = false;
  }
  const [tabValue, setTabValue] = React.useState(testValue);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <StyledAppBar position="sticky">
      <Container maxWidth="xl">
        <StyledToolbar disableGutters>
          <Box>
            <AppSwitcher {...props}></AppSwitcher>
          </Box>
          <Divider orientation="vertical" flexItem />
          {/* <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: `"Roboto-Black", "Roboto Black", "Roboto", sans-serif`,
              // fontWeight: 900,
              color: "#f2f2f2",
            }}
            onClick={() => props.history.push("/")}
            style={{ cursor: "pointer" }}
          >
            {props.appName}
          </Typography> */}
          <Box
            sx={{
              ml: 2,
              mr: 2,
              mt: 1,
              transform: "scale(0.9)",
              // display: "flex",
              alignItems: "center",
              display: { xs: "none", md: "flex" },
              // fontFamily: `"Roboto-Black", "Roboto Black", "Roboto", sans-serif`,
              // // fontWeight: 900,
              // color: "#f2f2f2",
            }}
            onClick={() => props.history.push("/")}
            style={{ cursor: "pointer" }}
          >
            <Logo product={"FlukeWorks"} />
          </Box>

          {/* <SwitchOrganization /> */}

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={(e) => {
                    if (page === "Assets") {
                      return props.history.push("/asset-list");
                    } else {
                      alert("Coming Soon!");
                    }
                    handleCloseNavMenu(e);
                  }}
                >
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            onClick={() => props.history.push("/")}
            style={{ cursor: "pointer" }}
          >
            {props.appName}
          </Typography> */}
          <Box
            sx={{
              mr: 2,
              mt: 1,
              transform: "scale(0.9)",
              // display: "flex",
              alignItems: "center",
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              // fontFamily: `"Roboto-Black", "Roboto Black", "Roboto", sans-serif`,
              // // fontWeight: 900,
              // color: "#f2f2f2",
            }}
            onClick={() => props.history.push("/")}
            style={{ cursor: "pointer" }}
          >
            <Logo product={"FlukeWorks"} />
          </Box>

          <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
            <Tabs
              sx={{
                minHeight: "55px",
                ".Mui-selected": {
                  backgroundColor: "#FFC20E",
                  "&:hover": {
                    backgroundColor: "#FFC20E !important",
                    color: "#222222 !important",
                  },
                  color: "#222222 !important",
                  borderRadius: "0 !important",
                },
                ".MuiTab-root": {
                  borderRadius: "0 !important",
                  height: "55px",
                  "&:hover": {
                    backgroundColor: "#000000",
                    color: "#FFC20E",
                  },
                },
                ".MuiTabs-indicator": {
                  backgroundColor: "#FFC20E !important",
                },
              }}
              value={tabValue}
              onChange={(e, newValue) => {
                setTabValue(newValue);
                if (newValue === 0) {
                  return props.history.push("/");
                } else if (newValue === 1) {
                  return props.history.push("/asset-list");
                } else if (newValue === 2) {
                  return props.history.push("/work-events");
                } else if (newValue === 3) {
                  return props.history.push(
                    `/my-org/${currentOrganization?.id}`
                  );
                } else if (newValue === 4) {
                  return props.history.push("/customers");
                } else {
                  alert("Coming Soon!");
                }
                handleCloseNavMenu(e);
              }}
              aria-label="columbia tabs"
            >
              {pages.map((page, i) => (
                <Tab
                  key={page}
                  // onClick={}
                  // sx={{
                  //   mr: 4,
                  //   color: "white",
                  //   // borderRadius: 0,
                  //   // height: "100%",
                  //   // display: "flex",
                  //   // alignItems: "center",
                  // }}
                  label={<Typography>{page}</Typography>}
                  {...a11yProps(i)}
                />
              ))}
            </Tabs>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }} />

          <Divider orientation="vertical" flexItem />
          <Box sx={{ flexGrow: 0 }}>
            <AccountMenu {...props}></AccountMenu>
          </Box>
        </StyledToolbar>
      </Container>
    </StyledAppBar>
  );
};

const StyledAppBar = styled(AppBar)`
  background: #222222;
`;

const StyledToolbar = styled(Toolbar)`
  height: 50px;
  @media (min-width: 600px) {
    min-height: 55px;
  }
`;
export default ResponsiveAppBar;
